import { render } from "./DashboardMain.vue?vue&type=template&id=52da4423"
import script from "./DashboardMain.vue?vue&type=script&lang=js"
export * from "./DashboardMain.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/DashboardMain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52da4423"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52da4423', __exports__)) {
    console.log('reload')
    api.reload('52da4423', __exports__)
  }
  
  module.hot.accept("./DashboardMain.vue?vue&type=template&id=52da4423", () => {
    console.log('re-render')
    api.rerender('52da4423', render)
  })

}


export default __exports__